import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AuthGuard } from '../data/guard/auth.guard';
import { FeatureArrivalGuard } from '../data/guard/feature-arrival.guard';
import { FormCanDeactivateGuard } from '../data/guard/form-can-deactivate.guard';
import { LoginGuard } from '../data/guard/login.guard';
import { EventResolver } from '../data/resolvers/event.resolver';
import { ActivesoftIntegrationService } from '../data/services/activesoft-integration.service';
import { GateGatewayService } from '../data/services/arrival/gate-gateway.service';
import { GateService } from '../data/services/arrival/gate.service';
import { GatesMonitoringService } from '../data/services/arrival/gates-monitoring.service';
import { AuthService } from '../data/services/auth.service';
import { ChatMessageToSendService } from '../data/services/chat-message-to-send.service';
import { ChatsGatewayService } from '../data/services/chats-gateway.service';
import { ChatsMessagesService } from '../data/services/chats-messages.service';
import { ChildService } from '../data/services/child.service';
import { ClassRoomsService } from '../data/services/classroom.service';
import { ContractedFeatureService } from '../data/services/contracted-feature.service';
import { SignInService } from '../data/services/sign-in.service';
import { EventQueueService } from '../data/services/event-queue.service';
import { EventsService } from '../data/services/events.service';
import { FileService } from '../data/services/file.service';
import { IntegrationService } from '../data/services/integration.service';
import { NewsService } from '../data/services/news.service';
import { PreviousRouteService } from '../data/services/previousRoute.service';
import { ProfileGuard } from '../data/guard/profile.guard';
import { ProfileService } from '../data/services/profile.service';
import { PushNotificationService } from '../data/services/push-notification.service';
import { RoomsMessagesService } from '../data/services/rooms-messages.service';
import { RoomsService } from '../data/services/rooms.service';
import { TreeProfilesService } from '../data/services/tree-services/tree-profiles.service';
import { TreeSegmentsService } from '../data/services/tree-services/tree-segments.service';
import { UsersService } from '../data/services/user.service';
import { UsersMessagesService } from '../data/services/users-messages.service';
import { VisualizedOccasionsService } from '../data/services/visualized-occasions.service';
import { GateChangesSocket } from '../data/sockets/gates/gate-changes.socket';
import { SignOutService } from '../data/services/sign-out.service';
import { SelectTenantService } from '../data/services/select-tenant.service';
import { AuthIdentityService } from '../data/services/auth-identity.service';
import { SelectUserSchoolService } from '../data/services/select-user-school.service';

@NgModule({
  imports: [CommonModule],

  providers: [
    FormCanDeactivateGuard,
    AuthGuard,
    LoginGuard,
    AuthService,
    ProfileGuard,
    FeatureArrivalGuard,
    UsersService,
    ChatsGatewayService,
    ProfileService,
    NewsService,
    FileService,
    EventsService,
    ClassRoomsService,
    RoomsService,
    RoomsMessagesService,
    UsersMessagesService,
    PreviousRouteService,
    ChildService,
    TreeProfilesService,
    TreeSegmentsService,
    ChatsMessagesService,
    ChatMessageToSendService,
    EventResolver,
    PushNotificationService,
    GateService,
    GatesMonitoringService,
    ContractedFeatureService,
    GateChangesSocket,
    GateGatewayService,
    IntegrationService,
    ActivesoftIntegrationService,
    SignInService,
    EventQueueService,
    VisualizedOccasionsService,
    SignOutService,
    SelectTenantService,
    AuthIdentityService,
    SelectUserSchoolService
  ],
})
export class AppServicesModule {}
